module.exports = __webpack_public_path__ + "static/ab-test-270b1dea209c02d3185ee816dbdb8407.png";